import toggleDropdown from './toggleDropdown.js';

var initializeDropdownMenu = function(currentElement){
  var allDropdownPaneLinks = currentElement.querySelectorAll('.dropdownpane-link');
  allDropdownPaneLinks.forEach(function(dropdownPaneLink) {
    if (dropdownPaneLink.hasAttribute('open-pane')) {
      dropdownPaneLink.nextElementSibling.classList.add('is-open');
      dropdownPaneLink.classList.add('active');
      
      var totalHeight = (dropdownPaneLink.nextElementSibling.classList.contains('list-dropdown')) ? 
                        dropdownPaneLink.nextElementSibling.offsetParent.parentElement.offsetTop + dropdownPaneLink.nextElementSibling.offsetHeight : 
                        dropdownPaneLink.nextElementSibling.offsetParent.offsetTop + dropdownPaneLink.nextElementSibling.offsetParent.offsetHeight + dropdownPaneLink.nextElementSibling.offsetHeight ;
      var endOfPageOffset = currentElement.querySelector(".end-view") ? currentElement.querySelector(".end-view").offsetTop : totalHeight;
      if(totalHeight > endOfPageOffset) { 
        dropdownPaneLink.nextElementSibling.classList.add('bottom');
      } else { 
        dropdownPaneLink.nextElementSibling.classList.remove('bottom');
      }
    } else if (dropdownPaneLink.nextElementSibling.classList.contains('is-open')) {
      dropdownPaneLink.nextElementSibling.classList.remove('is-open');
      dropdownPaneLink.classList.remove('active');
    }
    dropdownPaneLink.addEventListener('click', function(event) {
      event.stopPropagation();
      event.preventDefault();
      toggleDropdown(event, currentElement);
      if (dropdownPaneLink.nextElementSibling.classList.contains('is-open')) {
        dropdownPaneLink.nextElementSibling.classList.remove('is-open');
        dropdownPaneLink.classList.remove('active');
      } else {
        dropdownPaneLink.nextElementSibling.classList.add('is-open');
        dropdownPaneLink.classList.add('active');
        var totalHeight = (dropdownPaneLink.nextElementSibling.classList.contains('list-dropdown')) ? 
                          dropdownPaneLink.nextElementSibling.offsetParent.parentElement.offsetTop + dropdownPaneLink.nextElementSibling.offsetHeight : 
                          dropdownPaneLink.nextElementSibling.offsetParent.offsetTop + dropdownPaneLink.nextElementSibling.offsetParent.offsetHeight + dropdownPaneLink.nextElementSibling.offsetHeight;

        var endOfPageOffset = currentElement.querySelector(".end-view") ? currentElement.querySelector(".end-view").offsetTop : totalHeight;
        if(totalHeight > endOfPageOffset) { 
          dropdownPaneLink.nextElementSibling.classList.add('bottom');
        } else { 
          dropdownPaneLink.nextElementSibling.classList.remove('bottom');
        }
      }
    }.bind(this));
  }.bind(this));
  
  currentElement.addEventListener('click', function(event){
    toggleDropdown(event, currentElement);
  }.bind(this));
}

export default initializeDropdownMenu;